<template>
    <modal @close="changePasswordCancelClick" hideFooter class="edit-modal" id="change-password">
        <div class="td-edit-container one-step">

            <div class="pagination">
                <div class="form-name">
                    <h3>Change Password</h3>
                    <p>
                        You can easily update your password here. For your security, remember to choose a strong, unique password that you haven't used on other websites.
                    </p>
                    <p>
                        Password must be a minimum of 6 characters.
                    </p>
                </div>
            </div>
            <div class="edit-pages">
                <form>
                    <h3>Change Password</h3>

                    <div class="mt-3">
                        <label class="td-label td-text-bold mt-0">New Password:</label>
                        <input v-model="form.newPassword" type="password" autocomplete="new-password" placeholder="" :class="{'error': changePasswordValidator.errors['newPassword']}"
                               @input="changePasswordValidator.validate('newPassword')" />
                        <error v-if="changePasswordValidator.errors['newPassword']" :error="changePasswordValidator.errors['newPassword']"></error>
                    </div>

                    <div class="mt-3">
                        <label class="td-label td-text-bold mt-0">Confirm New Password:</label>
                        <input v-model="form.confirmPassword" type="password" inputmode="new-password" placeholder="" :class="{'error': changePasswordValidator.errors['confirmPassword']}"
                               @input="changePasswordValidator.validate('confirmPassword')" />
                        <error v-if="changePasswordValidator.errors['confirmPassword']" :error="changePasswordValidator.errors['confirmPassword']"></error>
                    </div>
                </form>
                <div class="actions" style="margin-top: 50px;">
                    <div>
                        <button class="td-text-left td-btn primary-outlined" @click="changePasswordCancelClick">Cancel</button>
                    </div>

                    <div class="save-btn">
                        <button class="td-text-right td-btn btn primary" @click="changePasswordSaveClick"><span v-if="isLoading"><icon name="faSpinner" type="solid" spin></icon>&nbsp;</span>Save</button>
                    </div>
                </div>
            </div>
            
        </div>
    </modal>
</template>

<script>
    import script from './ChangePassword';
    export default script;
</script>
<style lang="less">
    @import './ChangePassword.less';
</style>